import React from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {Link, withRouter} from 'react-router-dom';
import {observer} from 'mobx-react';
import DeleteCycleModal from './DeleteCycleModal';
import ArchiveCycleModal from './ArchiveCycleModal';
import {AvatarList, Tag, Button, Panel} from 'components';

const CycleAvatarList = ({title, employees}) => {
  return (
    <div className='inline-block mt2 pr3'>
      <div className='table-cell align-middle'>
        <AvatarList employees={employees}/>
      </div>
      <div className='table-cell align-middle'>
        <div className='h4 jumbo'>{title}</div>
      </div>
    </div>
  );
};

const TagFactory = observer(({cycle}) => {
  if (cycle.status === 'archived') {
    return (<Tag colour='rose'><FormattedMessage id="performance.Archived"/></Tag>);
  } else if (cycle.status === 'draft') {
    return (<Tag><FormattedMessage id="performance.Draft"/></Tag>);
  } else {
    return null;
  }
});

const CycleHeader = observer(({cycle}) => {
  return (
    <div className='clearfix'>
      <div className='table-cell align-middle pr2'>{cycle.title}</div>
      <div className='table-cell align-middle'>
        <TagFactory cycle={cycle}/>
      </div>
    </div>
  );
});

const DeleteLink = observer(({cycle, uiState}) => {
  if (cycle.links.archive) {
    return (
      <div onClick={(e) => {e.preventDefault(); uiState.archiveCycle = cycle;}} className='py1 px3 regular jumbo clickable'>
        <FormattedMessage id='performance.Archive'/>
      </div>
    );
  } else {
    return (
      <div onClick={(e) => {e.preventDefault(); uiState.deleteCycle = cycle;}} className='py1 px3 regular jumbo clickable'>
        <FormattedMessage id='performance.Delete'/>
      </div>
    );
  }
});

const CycleItem = injectIntl(({cycle, uiState, intl, history}) => {
  return (
    <div className='col col-12 px2 pb3'>
      <Link to={(cycle.status === 'draft') ? cycle.url : `${cycle.url}reviewees`}>
        <Panel>
          <Panel.Header title={<CycleHeader cycle={cycle}/>}>
            <div className='px1 dropdown inline-block'>
              <i className='HoverAnimation-trigger--image h1 material-icons submarine align-middle' data-toggle='dropdown'>{'more_horiz'}</i>
              <ul className='dropdown-menu right-0'>
                <li><div onClick={(e) => {e.preventDefault(); history.push(cycle.url);}} className='py1 px3 regular jumbo clickable'><FormattedMessage id='performance.Edit'/></div></li>
                <li><DeleteLink cycle={cycle} uiState={uiState}/></li>
              </ul>
            </div>
          </Panel.Header>
          <div className='clearfix'>
            <div className='col col-12'>
              <div className='clearfix'>
                <i className='h3 waterloo inline align-top material-icons pr1'>{'access_time'}</i>
                <div className='h4 jumbo inline'>
                  {cycle.frequency ? <FormattedMessage id='performance.REOCCURING_FREQUENCY' values={{frequency: <FormattedMessage id={`performance.${cycle.frequency}`} /> }}/> : <FormattedMessage id='performance.Frequency not set' />}
                </div>
              </div>
              <div className='clearfix mt2'>
                {!!cycle.totalManagers &&
                  <CycleAvatarList
                    title={intl.formatMessage({id: 'NUMBER_OF_LEADERS'}, {leaderCount: cycle.totalManagers})}
                    employees={cycle.managerAvatars}
                  />}
                {!cycle.totalManagers && <div className='waterloo mt2'>
                  <FormattedMessage id='performance.No managers assigned'/>
                </div>}
                {!!cycle.totalEmployees &&
                  <CycleAvatarList
                    title={intl.formatMessage({id: 'NUMBER_OF_EMPLOYEES'}, {employeeCount: cycle.totalEmployees})}
                    employees={cycle.employeeAvatars}
                  />}
              </div>
            </div>
          </div>
        </Panel>
      </Link>
    </div>
  );
});

const CycleDirectory = observer(({cycles, onCheckInCreated, uiState, onCycleDeleted, onCycleArchived, onCycleClicked, history}) => {
  return (
    <div>
      <div className='clearfix'>
        <div className='right mb3'>
          <Button onClick={onCheckInCreated}>
            <FormattedMessage id='performance.New Check-In Cycle'/>
          </Button>
        </div>
      </div>
      <div className='flex flex-wrap content-stretch mxn2'>
        {cycles.map(cycle => <CycleItem cycle={cycle} key={cycle.id} uiState={uiState} onCycleClicked={onCycleClicked} history={history} />)}
      </div>
      <DeleteCycleModal deleteCycle={uiState.deleteCycle} onCancel={() => uiState.deleteCycle = null} onDelete={onCycleDeleted} />
      <ArchiveCycleModal archiveCycle={uiState.archiveCycle} onCancel={() => uiState.archiveCycle = null} onArchive={onCycleArchived} />
    </div>
  );
});

export default withRouter(CycleDirectory);
